import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utilities/core/cn";
import { Slot } from "@radix-ui/react-slot";
import { type VariantProps, cva } from "class-variance-authority";
import * as React from "react";
const buttonVariants = cva("inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-pointer", {
  defaultVariants: {
    size: "default",
    variant: "default"
  },
  variants: {
    size: {
      clear: "",
      default: "h-10 px-4 py-2",
      icon: "h-10 w-10",
      lg: "h-11 px-8",
      sm: "h-9 px-3"
    },
    variant: {
      default: "btn-primary",
      destructive: "bg-destructive text-destructive-foreground",
      ghost: "btn-plain",
      link: "link-themed items-start justify-start underline-offset-4 hover:underline",
      outline: "border border-border bg-background"
    }
  }
});
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
}
const Button: React.FC<ButtonProps> = t0 => {
  const $ = _c(16);
  let className;
  let props;
  let ref;
  let size;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      asChild: t1,
      className,
      size,
      variant,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = size;
    $[5] = t1;
    $[6] = variant;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    size = $[4];
    t1 = $[5];
    variant = $[6];
  }
  const asChild = t1 === undefined ? false : t1;
  const Comp = asChild ? Slot : "button";
  let t2;
  if ($[7] !== className || $[8] !== size || $[9] !== variant) {
    t2 = cn(buttonVariants({
      className,
      size,
      variant
    }));
    $[7] = className;
    $[8] = size;
    $[9] = variant;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== Comp || $[12] !== props || $[13] !== ref || $[14] !== t2) {
    t3 = <Comp className={t2} ref={ref} {...props} />;
    $[11] = Comp;
    $[12] = props;
    $[13] = ref;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export { Button, buttonVariants };